import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal } from './Modal'
import { HeaderModal } from './Header'
import { Body } from './Body'
import { FooterModal } from './Footer'
import useAppState from 'context/useAppState';
import CustomSelect from 'components/common/CustomSelect';
import { optionProp } from 'types';
import closeIcon from 'assets/images/close-icon.svg';
import modalBgShade from "../../../assets/images/bg-modal-shade.svg";
import { PLANNER_TEXT, TEAM_TEXT } from 'utils/constant';

interface LeaveModalType {
    isShow: boolean;
    actionType: string;
    dropDownLabel: string;
    onCloseModal?: any,
    options?: [{ label: "hello", value: "hello" }],
    title: string;
    btnText: string;
    subTitle: string;
    icon: string
    onSubmit?: any,
    error: string | null;
    setError: any;
    getPlannerRecord?: any,
    setIsShowSettingModal?: any;
    selectedValueOfRemoveUser?:optionProp|null
    setSelectedValueOfRemoveUser?:any;
}

function LeavePlanner(
    { isShow, title, icon, subTitle, dropDownLabel, actionType, btnText, error, setError, onCloseModal, setIsShowSettingModal, }: LeaveModalType) {
    const { getCollaboratorsRecord, selectedMember,showRemoveUserModal, updatedCollaborators, selectedUser, collaboratorsList, transferUser, LeaveUser, removeUser,selectedRemoveUser, fetchCollaborators, setState, } = useAppState("boardData");

    const { fetchEventData } = useAppState('eventData');
    const { id } = useParams();

    const userData = localStorage.getItem('userData') as string;
    const user = JSON.parse(userData);

    const [updatedCollaboratorList, setUpdateCollaboratorList] = useState([]);
    const [removeUserModalDropdownList, setRemoveUserModalDropdownList] = useState([]);
    // const [selectedValueOfRemoveUser, setSelectedValueOfRemoveUser] = useState<optionProp | null>(null);


    useEffect(() => {
        // fetch collaborator list
        if (id && isShow) {
            getCollaboratorsRecord(id);
        }
    }, [isShow]);

    // filter the collaboratorList we don't need to show the owner data in list
    const filteredUserData = useMemo(() => {
        if (collaboratorsList.length > 0) {
            const updatedData = collaboratorsList.filter((item: any) => {
                return user.id !== item.user_id;
            });
            setUpdateCollaboratorList(updatedData);
        }
    }, [collaboratorsList, user.id]);

    // created value and option to pass in dropdownList 
    useEffect(() => {
        const result: any = [];
        if (updatedCollaboratorList.length > 0) {
            updatedCollaboratorList.forEach((element: any) => {
                result.push({ value: element.user_name, label: element.user_name, data: element })
            });
            setState({
                updatedCollaborators: result,
            })
        }
    }, [updatedCollaboratorList])

    // default value selected to removeUser in modal
    // useEffect(() => {
    //     if (selectedMember && removeUserModalDropdownList.length > 0) {
    //         setSelectedValueOfRemoveUser(removeUserModalDropdownList[0])
    //     }
    // }, [selectedMember])

    // filter data based on the selectedMember 
    useMemo(() => {
        if (collaboratorsList.length > 0) {
            const result: any = []
            const updatedData = collaboratorsList.filter((item: any) => {
                return item.user_id !== selectedMember?.user_id;
            })
            updatedData.forEach((element: any) => {
                result.push({ value: element.user_name, label: element.user_name, data: element })
            });
            setRemoveUserModalDropdownList(result);
        }

    }, [collaboratorsList,selectedMember])


    // handle submit based on user role
    const handleSubmit = async (event: any) => {
        event.preventDefault();

        if (selectedUser === null && actionType === "transferUser") {
            setError(TEAM_TEXT);
        } else if (selectedUser === null && actionType === "leavePlanner") {
            setError(PLANNER_TEXT)
        } else if (selectedRemoveUser === null) {
            setError(PLANNER_TEXT)
        } else if (actionType === "transferUser") {
            const payload = {
                owner_id: user.id,
                new_owner_id: selectedUser.data.user_id
            }

            await transferUser(id, payload)
            await fetchEventData(id);
            setIsShowSettingModal(false);
            setState({selectedUser:null})
            setState({updatedCollaborators:[],updatedCollaboratorList:[] });
        } else if (actionType === "leavePlanner") {
            const payload = {
                owner_id: user.id,
                new_owner_id: selectedUser.data.user_id
            }

            await LeaveUser(id, payload);
            fetchEventData(id);
            setState({showLeavePlanner:false,selectedUser:null })
            setState({updatedCollaborators:[],updatedCollaboratorList:[] });
            // fetchCollaborators(id);
        } else {
            const payload = {
                owner_id: user.id,
                user_id: selectedMember.user_id,
                new_user_id: selectedUser.data.user_id
            }
            await removeUser(id, payload);
            await fetchCollaborators(id)
            setState({showRemoveUserModal: false,selectedRemoveUser:null,selectedUser:null });
            setRemoveUserModalDropdownList([]);
        }
        
    }

    const handleSelect= (selectedData: optionProp) => {
        setState({ selectedUser: selectedData, selectedRemoveUser:selectedData });
        setError(null);
    }

    return (
        <div>
            <Modal className={"modal-wrapper max-w-[400px]"} isShow={isShow} >
                <form onSubmit={handleSubmit}>

                    {/* Modal bg Shade */}
                    <img className="absolute top-0.5 left-0 object-contain -z-10" src={modalBgShade} alt="shade" />

                    <HeaderModal title={title} isShowHeader={true} className="modal-header pt-6 px-6">
                        <img className="cursor-pointer w-12 h-12 mb-4" src={icon} alt="remove" />
                        <div className="flex items-center justify-between">
                            <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">{title}</h2>
                            {/* Close Icon */}
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 -mt-[130px]"
                                id="modal-toggle"
                                src={closeIcon}
                                onClick={onCloseModal}
                                alt="close icon"
                            />
                        </div>

                        <p className="text-sm text-[#475467]">
                            {subTitle}
                        </p>
                    </HeaderModal>

                    <Body title="" isShowBody={true} className="modal-body px-6 pt-5">
                        <div className="mb-10">
                            <p className="text-[15px] text-[#344054] font-interMedium pb-1.5">{dropDownLabel}</p>
                            <div className="modal-select-box fete-settings-modals">
                                <CustomSelect
                                    selectedValue={actionType === "removeUser" ? selectedRemoveUser : selectedUser}
                                    options={actionType == "removeUser" ? removeUserModalDropdownList : updatedCollaborators}
                                    onChange={(selectedData) => handleSelect(selectedData)}
                                    extendedOption={false}
                                />
                            </div>
                            <p className='text-red-600'>{error}</p>
                        </div>
                    </Body>

                    <FooterModal title="" isShowFooter={true} className="modal-footer pt-4 px-6 pb-4">
                        <div className="flex items-center gap-x-3 justify-center">
                            <button
                                className={`text-[#fff] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base flex-1 ${actionType === "transferUser" ? 'bg-[#1E0AF5] hover:bg-[#120693]' : 'bg-red-600 hover:bg-[#B42318]'} ${!selectedUser ? 'button-disabled' : ''}`}
                            // onClick={onCloseModal}
                            >
                                {btnText}
                            </button>
                        </div>
                    </FooterModal>
                </form>

            </Modal>
        </div>
    )
}

export default LeavePlanner